import { c as _c } from "react/compiler-runtime";
import { AxiosResponse } from 'axios';
import { XENDIT_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/xendit/api';
import { XenditCreateIntegrationInterface, XenditPaymentIntegrationInterface, XenditUpdateIntegrationInterface } from 'modules/profile/payment-gateways/integrations/xendit/types';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useCreateXenditIntegration = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      createXenditIntegration: data => fetcher(`${XENDIT_ACCOUNT_API}/connect`, data)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useUpdateXenditIntegration = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      updateXenditIntegration: async data => await fetcher(`${XENDIT_ACCOUNT_API}/update`, data)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};